import {gsap} from 'gsap'
import {ScrollTrigger} from 'gsap/ScrollTrigger'
import {SplitText} from 'gsap/SplitText'

gsap.registerPlugin(ScrollTrigger)
gsap.registerPlugin(SplitText)

export default class Animations {
  static init() {
    console.debug('== Animations components ==')

    const main = document.querySelector('.main-wrapper')

    // Menu show/hide animation
    console.debug('  -> Animate menu')

    const header = document.querySelector('.header')
    const headerHeight = header.offsetHeight
    const offsetMenu = headerHeight + 50

    let prevScrollTop = document.documentElement.scrollTop
    let currrentScrollTop = document.documentElement.scrollTop

    document.addEventListener('scroll', (e) => {
      // update current scroll top
      currrentScrollTop = document.documentElement.scrollTop

      // when we are at the top of the page the menu should never disappear
      if (currrentScrollTop <= offsetMenu) {
        header.classList.remove('header--hidden')
      } else {
        // detect scrolling direction
        if (currrentScrollTop > prevScrollTop) {
          header.classList.add('header--hidden')
        } else {
          header.classList.remove('header--hidden')
        }
      }

      // update previous scroll top
      prevScrollTop = document.documentElement.scrollTop
    })

    // Hero animations (general)

    console.debug('  -> Animate hero on scroll')

    const heroMain = document.querySelector('.component-hero')

    if (heroMain) {
      document.addEventListener('scroll', (e) => {
        if (currrentScrollTop > 0) {
          heroMain.classList.add('component--hero-animated')
        } else {
          heroMain.classList.remove('component--hero-animated')
        }
      })
    }

    // Homepage hero animation
    if (main.classList.contains('front-page')) {
      // Getting hero components
      const heroHomepage = document.querySelector(
        '.section--hero.component-hero'
      )

      heroHomepage.querySelector('.component-title').classList.remove('h-first-view')
      heroHomepage.querySelector('.component-subtitle').classList.remove('h-first-view')

      const splittedHeroTitle = new SplitText(
        '.section--hero.component-hero .component-title',
        {type: 'lines', linesClass: 'h-will-change-transform'}
      )
      const splittedHeroSubitle = new SplitText(
        '.section--hero.component-hero .component-subtitle',
        {type: 'lines', linesClass: 'h-will-change-transform'}
      )

      console.debug('  -> Animate main viewport')

      const tlMainViewport = gsap.timeline()

      tlMainViewport
        // .from(header, {
        //   autoAlpha: 0,
        //   delay: 0.25,
        //   duration: 1,
        //   ease: 'expo.out',
        // })
        .from(heroHomepage, {
          autoAlpha: 0,
          delay: -0.75,
          duration: 1,
          ease: 'expo.out',
        })
        .from(splittedHeroTitle.lines, {
          autoAlpha: 0,
          delay: -0.5,
          duration: 1,
          y: 40,
          ease: 'expo.out',
          stagger: 0.1,
        })
        .from(splittedHeroSubitle.lines, {
          autoAlpha: 0,
          delay: -0.475,
          duration: 1,
          y: 40,
          ease: 'expo.out',
          stagger: 0.1,
        })
    }

    // Parallax animation for trend block (tablets)
    const sectionTrend = document.querySelector('.section--trend')

    if (sectionTrend) {
      console.debug('  -> Animate trend block with parallax')

      const sectionBox = sectionTrend.querySelector('.section-box-image')
      const tablet1 = sectionTrend.querySelector('#tablet-1')
      const tablet2 = sectionTrend.querySelector('#tablet-2')

      const tlTrend = gsap.timeline()

      tlTrend
        .from(tablet1, {
          yPercent: -100,
          ease: 'expo.out',
          scrollTrigger: {
            trigger: sectionBox,
            scrub: 1,
          },
        })
        .from(tablet2, {
          yPercent: 40,
          ease: 'expo.out',
          scrollTrigger: {
            trigger: sectionBox,
            scrub: 1,
          },
        })
    }

    // General animations

    console.debug('  -> Animate general components')

    const animateRight = document.querySelectorAll('.animate-right')
    if (animateRight.length != 0) {
      animateHorizontal(animateRight, 40)
    }

    const animateLeft = document.querySelectorAll('.animate-left')
    if (animateLeft.length != 0) {
      animateHorizontal(animateLeft, -40)
    }

    const animateBottom = document.querySelectorAll('.animate-bottom')
    if (animateBottom.length != 0) {
      animateVertical(animateBottom, 20)
    }

    const animateTop = document.querySelectorAll('.animate-top')
    if (animateTop.length != 0) {
      animateVertical(animateTop, -20)
    }

    const animateBottomLately = document.querySelectorAll(
      '.animate-bottom-lately'
    )
    if (animateBottomLately.length != 0) {
      animateVertical(animateBottomLately, 20, 'top 75%')
    }

    const animateFadeItems = document.querySelectorAll('.animate-fade')
    if (animateFadeItems.length != 0) {
      animateFade(animateFadeItems)
    }

    const animateBottomStaggerMultiboxHome = document.querySelectorAll(
      '.animate-bottom-stagger-multibox-home'
    )
    if (animateBottomStaggerMultiboxHome.length != 0) {
      animateBottomStagger(animateBottomStaggerMultiboxHome, 20, 0.2)
    }

    const animateBottomStaggerTrust = document.querySelectorAll(
      '.animate-bottom-stagger-trust'
    )
    if (animateBottomStaggerTrust.length != 0) {
      animateBottomStagger(animateBottomStaggerTrust, 20, 0.15)
    }

    const animateBottomStaggerVideos = document.querySelectorAll(
      '.animate-bottom-stagger-video'
    )
    if (animateBottomStaggerVideos.length != 0) {
      animateBottomStagger(animateBottomStaggerVideos, 20, 0.13)
    }

    const animateBottomStaggerNumbers = document.querySelectorAll(
      '.animate-bottom-stagger-numbers'
    )
    if (animateBottomStaggerNumbers.length != 0) {
      animateBottomStagger(animateBottomStaggerNumbers, 20, 0.15)
    }

    const animateBottomStaggerSteps = document.querySelectorAll(
      '.animate-bottom-stagger-steps'
    )
    if (animateBottomStaggerSteps.length != 0) {
      animateBottomStagger(animateBottomStaggerSteps, 20, 0.2)
    }

    const animateBottomStaggerYesterdayNow = document.querySelectorAll(
      '.animate-bottom-stagger-yesterday-now'
    )
    if (animateBottomStaggerYesterdayNow.length != 0) {
      animateBottomStagger(animateBottomStaggerYesterdayNow, 20, 0.2)
    }

    const animateBottomStaggerModel = document.querySelectorAll(
      '.animate-bottom-stagger-model'
    )
    if (animateBottomStaggerModel.length != 0) {
      animateBottomStagger(animateBottomStaggerModel, 20, 0.2)
    }

    const animateBottomStaggerCreditLine = document.querySelectorAll(
      '.animate-bottom-stagger-creditline'
    )
    if (animateBottomStaggerCreditLine.length != 0) {
      animateBottomStagger(animateBottomStaggerCreditLine, 20, 0.2)
    }

    const animateBottomStaggerSplit = document.querySelectorAll(
      '.animate-bottom-stagger-split'
    )
    if (animateBottomStaggerSplit.length != 0) {
      animateBottomStagger(animateBottomStaggerSplit, 20, 0.2)
    }

    const animateBottomStaggerGuarantee = document.querySelectorAll(
      '.animate-bottom-stagger-guarantee'
    )
    if (animateBottomStaggerGuarantee.length != 0) {
      animateBottomStagger(animateBottomStaggerGuarantee, 20, 0.2)
    }

    const animateBottomStaggerPaycheck = document.querySelectorAll(
      '.animate-bottom-stagger-paycheck'
    )
    if (animateBottomStaggerPaycheck.length != 0) {
      animateBottomStagger(animateBottomStaggerPaycheck, 20, 0.2)
    }

    // Page 404 Illustration animation
    console.debug('  -> Animate 404 page')

    const roadblockDesk = document.querySelector('#roadblock-wrapper-desk')
    if (roadblockDesk) {
      animateStripes(roadblockDesk, 0, 354)
    }

    const roadblockMobile = document.querySelector('#roadblock-wrapper-mobile')
    if (roadblockMobile) {
      animateStripes(roadblockMobile, 0, 141)
    }

  }

  static destroyScrolls() {
    ScrollTrigger.killAll()
  }
}

function animateHorizontal(items, offset) {
  items.forEach((item) => {
    let tlItem = gsap.timeline({paused: true})

    const property = item.classList.contains('h-first-view') ? 'autoAlpha' : 'opacity'

    tlItem.from(item, {
      [property]: 0,
      duration: 1,
      x: offset,
      ease: 'expo.out',
    })

    ScrollTrigger.create({
      trigger: item,
      start: 'top 95%',
      end: 'bottom 90%',
      animation: tlItem,
      markers: false,
      toggleActions: 'play none none reverse',
    })
  })
}

function animateVertical(items, offset, start = 'top 95%') {
  items.forEach((item) => {
    let tlItem = gsap.timeline({paused: true})

    const property = item.classList.contains('h-first-view') ? 'autoAlpha' : 'opacity'

    tlItem.from(item, {
      [property]: 0,
      duration: 1,
      y: offset,
      ease: 'expo.out',
    })

    ScrollTrigger.create({
      trigger: item,
      start: start,
      end: 'bottom 90%',
      animation: tlItem,
      markers: false,
      toggleActions: 'play none none reverse',
    })
  })
}

function animateFade(items) {
  items.forEach((item) => {
    let tlItem = gsap.timeline({paused: true})

    const property = item.classList.contains('h-first-view') ? 'autoAlpha' : 'opacity'

    tlItem.from(item, {
      [property]: 0,
      duration: 1,
      ease: 'expo.out',
    })

    ScrollTrigger.create({
      trigger: item,
      start: 'top 95%',
      end: 'bottom 90%',
      animation: tlItem,
      markers: false,
      toggleActions: 'play none none reverse',
    })
  })
}

function animateBottomStagger(items, offset, stagger) {
  let tlItem = gsap.timeline({paused: true})

  if( items.length > 0 ){
    tlItem.from(items, {
      opacity: 0,
      duration: 1,
      y: offset,
      ease: 'expo.out',
      stagger: stagger,
      delay: 0.25,
    })
  
    ScrollTrigger.create({
      trigger: items,
      start: 'top 95%',
      end: 'bottom 90%',
      animation: tlItem,
      markers: false,
      toggleActions: 'play none none reverse',
    })
  }
}

function animateStripes(roadblock, startX, endX) {

  const stripesContainer = roadblock.querySelector('.stripes-container');

    gsap.set(stripesContainer, { 
      translateX: startX,
    });

    gsap.to(stripesContainer, { 
        repeat: -1,
        duration: 7,
        translateX: endX,
        ease: "none",
    });
}